module.exports = __webpack_public_path__ + "static/media/error.d77a6a69.svg";